export const LEGAL_LAST_UPDATED = "April 6, 2026";

export const LEGAL_CONTACT_EMAIL = "legal@ateno.co";
export const PRIVACY_CONTACT_EMAIL = "privacy@ateno.co";
export const SUPPORT_CONTACT_EMAIL = "info@ateno.co";
